export interface CuratedTeacher {
  bio: string;
  display: boolean;
  email?: string;
  firstName: string;
  major: string;
  gradYear: number;
  id: string;
  lastName: string;
  latitude: number;
  schoolAddress: string;
  longitude: number;
  otherMajors?: string[];
  // minors?: string[];
  phone?: string;
  photoUrl?: string;
  district: string;
  quotes?: string[];
  schoolName: string;
  type: string;
}

// export const emptyTeacher: CuratedTeacher = {
//   bio: "",
//   display: true,
//   email: "",
//   firstName: "",
//   major: "",
//   gradYear: 0,
//   id: "",
//   lastName: "",
//   latitude: 0,
//   schoolAddress: "",
//   longitude: 0,
//   otherMajors: [],
//   phone: "",
//   photoUrl: "",
//   district: "",
//   quotes: [],
//   schoolName: "",
//   type: "",
// };

export const emptyTeacher: CuratedTeacher = {
  bio: "",
  display: true,
  district: "", // Moved before 'email'
  email: "",
  firstName: "",
  gradYear: 0, // Moved before 'id'
  id: "",
  lastName: "",
  latitude: 0,
  longitude: 0, // Moved before 'major'
  major: "",
  otherMajors: [],
  phone: "",
  photoUrl: "",
  quotes: [],
  schoolAddress: "", // Moved before 'schoolName'
  schoolName: "",
  type: "",
};
